export const AVAILABILITY_ACTION_TYPES = {
  FETCH_RELATED_COHORTS_START: 'FETCH_RELATED_COHORTS_START',
  FETCH_RELATED_COHORTS_SUCCESS: 'FETCH_RELATED_COHORTS_SUCCESS',
  FETCH_RELATED_COHORTS_FAILED: 'FETCH_RELATED_COHORTS_FAILED',
  SET_SELECTED_MENTOR: 'SET_SELECTED_MENTOR',
}
